import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { SubmenuTitle as UISubmenuTitle } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/SubmenuTitle/SubmenuTitle";
import { SubmenuTitle as MobileFirstUISubmenuTitle } from "@jti/ui/eva-components/MobileFirstHeader/components/SecondaryNavigation/components/SubmenuTitle";

import type { submenuTitleInputs } from "./SubmenuTitle.builder";

type SubmenuTitleBuilderProps = BuilderComponentProps<typeof submenuTitleInputs>;

export const SubmenuTitle: FC<SubmenuTitleBuilderProps> = ({
  title,
  descriptionPrefix,
  secondDescriptionPrefix,
  link,
  variant,
  showUserTier,
}) => {
  const { isMobileFirstNavigationEnabled } = useConfig();
  const SubmenuTitleComponent = isMobileFirstNavigationEnabled ? MobileFirstUISubmenuTitle : UISubmenuTitle;

  return (
    <SubmenuTitleComponent
      title={title}
      descriptionPrefix={descriptionPrefix}
      secondDescriptionPrefix={secondDescriptionPrefix}
      link={link}
      variant={variant}
      showUserTier={showUserTier}
    />
  );
};
